//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useContext } from 'react';
import { LLMContext } from '@/contexts/LLMContext';

/**
 * Access the active-LLM selection.  activeLLM is computed from the saved
 * preference + the configured models (see LLMProvider); setActiveLLM validates
 * against those models and persists the choice to the profile.
 */
export function useLLM() {
  const context = useContext(LLMContext);
  if (!context)
    throw new Error('useLLM must be used within an LLMProvider');

  return context;
}
